export const initialState = {
    user: null,
    patients: null,
    practices: null,
    practice:null,
    practicestats:null,
    batches:null,
    locations:null,
    visits:null,
    advanceSearchedPatients: null,
    smartListPatients: null,
    usersList: null,
    roles: null,
    medicalAssistants: null,
    racesNames: null,
    serviceProviderNames: null,
    setMaUserNames: null,
    practiceTimeZoneNames: null,
    practiceNames: null,
    healthIndicatorNames: null,
    defaultPageSize: 10,
    defaultPageSizeforReports: 100,
    defaultPageSizeforPatients:10,
    Records:{},
    vendors: null,
    vendorDevices: null,
    vendorNames: null,
    shipmentStatusNames: null,
    vendorDeviceNames: null,
    patientNames: null,
    safeRangeValues: null,
    scheduleVisits: null,
    notificationLogs: null,
  
    contacts: {
      byId: {},
      allIds: [],
    },
    threads: {
      byKey: {},
      allKeys: [],
    },
    sidebarOpen: false,
    notifications: [],
    mail: {
      mails: {
        byId: {},
        allIds: [],
      },
      labels: [],
      sidebarOpen: false,
      newMessageOpen: false,
    },
    isLoaded: false,
    lists: {
      byId: {},
      allIds: [],
    },
    cards: {
      byId: {},
      allIds: [],
    },
    members: {
      byId: {},
      allIds: [],
    },
    client: null,
    clients: [],
    users: [],
  
    dashboardContent: [],
    modules: [],
    subModules: [],
    selectedClient: 0,
    products: [],
    productsCounts: null,
    totalProducts: 0,
    totalArchievedProducts: 0,
    productsCSVData: "",
    archievedProducts: [],
    showArchievedProducts: false,
    showDraftedProducts: false,
    showLiveProducts: false,
    showProductsType: "",
    selectedFilteredProducts: [],
    orders: [],
    totalOrders: 0,
    loadingProducts: false,
    loadingOrders: false,
    marketplaces: [],
    ecommerceSystems: [],
    shippingTemplates: [],
    originOfCountries: [],
    collapseOpen: "",
    selectedCollapse: "",
    // Network Error with status code other than 200.
    showNetworkErrorAlert: false,
    // Network Error if internet is not working.
    internetConnectivityErrorAlert: false,
    report: null,
    page: 0,
    pageSize: 10,
    query: "",
    productStatuses: [],
    tags: [],
    tagTypes: [],
    // Trainings
    trainings: null,
    allActivities: null,
    trainingModules: null,
    trainingSessions: null,
    trainingCosts: null,
    trainingNames: [],
    trainingModuleNames: [],
    participants: null,
    organizationTypeNames: null,
    organizationNames: null,
    academicQualificationNames: null,
    provinceNames: [],
    districtNames: [],
    projectNames: [],
    surveyNames: [],
    broaderTrainingAreas: [],
    cityNames: [],
    trainingEvaluation: [],
    emailSmsLogs: null,
    smsGroups: null,
    emailGroups: null,
    trainingMapsData: [],
    donors_collaboratingagencies: null,
    libraryDocuments: null,
    donors_collaboratingagenciesprojectbriefReport: null,
    reconciliationfundingcostReport: null,
    organizationTypes: null,
    relationshipTypes: [],
    geographicalAreas: [],
    distrcitsNames: [],
    documentCategoriesNames: [],
    documentSubCategories1Names: [],
    documentSubCategories2Names: [],
    groups: null,
    courses: null,
    trainingCalendar: [],
    resourcePersons: [],
    employees: [],
    employeeEvents: [],
    projects: null,
    registeredUsers: null,
    albums: null,
    galleriesNames: [],
    galleryAbums: null,
    albumDocuments: null,
    projectFundings: null,
    approvedHeadNames: [],
    resourcePersonsTrainings: [],
    resourcePersonNames: [],
    trainingSessionNames: [],
    attachments: {
      pagination: {
        totalItemsCount: 0,
        pageSize: 10,
        currentPage: 1,
        totalPages: 0,
      },
      payload: [],
    },
    topicNames: [],
    quizzes: {
      pagination: {
        totalItemsCount: 0,
        pageSize: 10,
        currentPage: 1,
        totalPages: 0,
      },
      payload: [],
    },
    activities: null,
    activityTypeNames: [],
    registrations: {
      pagination: {
        totalItemsCount: 0,
        pageSize: 10,
        currentPage: 1,
        totalPages: 0,
      },
      payload: [],
    },
    trainingRegistrations: {
      pagination: {
        totalItemsCount: 0,
        pageSize: 10,
        currentPage: 1,
        totalPages: 0,
      },
      payload: [],
    },
    courseNames: null,
    participantNames: null,
    sections: {
      pagination: {
        totalItemsCount: 0,
        pageSize: 10,
        currentPage: 1,
        totalPages: 0,
      },
      payload: [],
    },
    topics: {
      pagination: {
        totalItemsCount: 0,
        pageSize: 10,
        currentPage: 1,
        totalPages: 0,
      },
      payload: [],
    },
    sectionNames: null,
    activitiesCosts: null,
    activitiesNames: [],
    fundingsNames: [],
    approvedHeads: null,
    activityTypes: null,
    quizAttempts: null,
    quizNames: null,
    quizQuestionTexts: null,
    thematicAreas: [],
    broaderTrainingAreasList: [],
    surveySections: [],
    surveySectionNames: [],
    provinces: [],
    documentAuthors: [],
    documentPublishers: [],
    compilingAgencies: [],
    districts: [],
    cities: [],
    allDistrictNames: [],
    documentCategories: [],
    documentCategoryNames: [],
    thematicAreaNames: [],
    documentPublisherNames: [],
    documentAuthorNames: [],
    compilingAgencyNames: [],
    websiteContents: [],
    disabilityTypes: null,
    academicQualifications: null,
    areasOfSpecialities: null,
    areasOfSpecialityNames: [],
    disabilityTypeNames: [],
    directorateTypeNames: [],
    federalDepartmentNames: [],
    provincialDepartmentNames: [],
    ndmaAppointmentsNames: [],
    ndmaSectionsNames: [],
  
    employeeEventTypeNames: [],
    employeeEventConductModeNames: [],
    employeeEventFundingStatusNames: [],
    employeeEventOrganizerNames: [],
    ndmaWingNames: [],
    armedForceTypeNames: [],
    consultantNames: [],
    adminUsersNames: [],
    myCourses: [],
    quizQuestions: {
      pagination: {
        totalItemsCount: 0,
        pageSize: 10,
        currentPage: 1,
        totalPages: 0,
      },
      payload: [],
    },
    liveTrainings: [],
    participantTrainings: [],
    donorsCollaboratingagencyOrganizations: [],
    sectionFilters: { courseId: 0 },
    topicFilters: { courseId: 0, sectionId: 0 },
    attachmentFilters: { courseId: 0, sectionId: 0, topicId: 0 },
    quizFilters: { courseId: 0, sectionId: 0, topicId: 0 },
    registrationFilters: { courseId: 0 },
    quizQuestionFilters: {
      courseId: 0,
      sectionId: 0,
      topicId: 0,
      quizId: 0,
    },
    redirectPath: null,
    fourWOrganizations: null,
    surveys: null,
    respondents: null,
    questions: null,
  
    fourWOrganizationNames: [],
    trainingModeNames: null,
    selectedCourseTab: "live",
    trainingEvaluations: null,
    rolePermissions: null,
    openPatientMainDialog: false,
    openPatientReadingsDialog: false,
  };
  